var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFF8E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.58 14.7204L11.64 43.0004C11.2908 43.6053 11.106 44.291 11.104 44.9894C11.1021 45.6879 11.283 46.3747 11.6289 46.9815C11.9748 47.5883 12.4735 48.0939 13.0755 48.4481C13.6774 48.8023 14.3616 48.9927 15.06 49.0004H48.94C49.6384 48.9927 50.3227 48.8023 50.9246 48.4481C51.5266 48.0939 52.0253 47.5883 52.3712 46.9815C52.7171 46.3747 52.898 45.6879 52.8961 44.9894C52.8941 44.291 52.7093 43.6053 52.36 43.0004L35.42 14.7204C35.0635 14.1326 34.5615 13.6466 33.9624 13.3094C33.3634 12.9721 32.6875 12.7949 32 12.7949C31.3126 12.7949 30.6367 12.9721 30.0377 13.3094C29.4386 13.6466 28.9366 14.1326 28.58 14.7204V14.7204Z",
    stroke: "#F4C20D",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25V33",
    stroke: "#F4C20D",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41H32.02",
    stroke: "#F4C20D",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.375189530cdd56475ffa086d99ae5de1.svg";
export { ForwardRef as ReactComponent };